(function () {
  'use strict';

  var observer = null;
  var debounceTimer = null;

  function isPromocjePage() {
    return /\/collections\/promocje\/?$/i.test(window.location.pathname);
  }

  function getRoot() {
    return document.getElementById('CollectionAjaxResult');
  }

  function getGrid(root) {
    if (!root) {
      return null;
    }
    return root.querySelector('.grid.grid--uniform');
  }

  function maAktywnaPromocje(tile) {
    if (tile.querySelector('.grid-product__price--original')) {
      return true;
    }

    if (tile.querySelector('.grid-product__price--savings')) {
      return true;
    }

    if (tile.querySelector('.grid-product__tag--sale')) {
      return true;
    }

    return false;
  }

  function aktualizujLicznik(root, widoczne) {
    root.querySelectorAll('[data-promocje-licznik-cel]').forEach(function (el) {
      var tekst = el.textContent || '';
      if (/\d+/.test(tekst)) {
        el.textContent = tekst.replace(/\d+/, String(widoczne));
      }
    });
  }

  function aktualizujPustyStan(grid, widoczne) {
    var pusty = grid.querySelector('[data-promocje-pusty-stan]');
    if (!pusty) {
      return;
    }

    if (widoczne === 0) {
      pusty.classList.remove('hide');
      pusty.hidden = false;
      pusty.style.removeProperty('display');
    } else {
      pusty.classList.add('hide');
      pusty.hidden = true;
      pusty.style.display = 'none';
    }
  }

  function filtrujKafelki(root, grid) {
    var kafelki = grid.querySelectorAll('.grid-product.grid__item');
    var widoczne = 0;

    kafelki.forEach(function (kafelek) {
      if (maAktywnaPromocje(kafelek)) {
        kafelek.classList.remove('promocje-filtr-ukryty');
        kafelek.style.removeProperty('display');
        kafelek.hidden = false;
        widoczne += 1;
      } else {
        kafelek.classList.add('promocje-filtr-ukryty');
        kafelek.style.display = 'none';
        kafelek.hidden = true;
      }
    });

    aktualizujLicznik(root, widoczne);
    aktualizujPustyStan(grid, widoczne);
  }

  function zaplanujFiltr(root, grid) {
    if (debounceTimer) {
      window.clearTimeout(debounceTimer);
    }

    debounceTimer = window.setTimeout(function () {
      filtrujKafelki(root, grid);
    }, 60);
  }

  function initPromocjeFiltr() {
    if (!isPromocjePage()) {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      return;
    }

    var root = getRoot();
    if (!root || root.getAttribute('data-promocje-kolekcja') !== 'true') {
      return;
    }

    var grid = getGrid(root);
    if (!grid) {
      return;
    }

    if (observer) {
      observer.disconnect();
      observer = null;
    }

    filtrujKafelki(root, grid);

    if (typeof MutationObserver !== 'undefined') {
      observer = new MutationObserver(function () {
        zaplanujFiltr(root, grid);
      });
      observer.observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromocjeFiltr);
  } else {
    initPromocjeFiltr();
  }

  document.addEventListener('shopify:section:load', initPromocjeFiltr);
})();
